import {Card, Row, Col} from 'antd';
import {fixedToDisplayUnit} from "../../util/unitutils";
import {UnitType} from "../../api/Constants";

export const HarvestedTotalCard = ({trim, refresh, onRefresh, onApiFail, props}) => {

    const cardStyle = {
        textAlign: 'left',
    }

    const rowStyle = {
        marginTop: '5px',
        marginBottom: '5px',
    }

    const productArray = Object.values(trim);

    return <Card style={cardStyle} title={<b>Harvest Totals</b>} >
        {(productArray.length > 0) && productArray.map(product => {
            const {name, amount, productId} = product;
            const unit = UnitType.Gram;
            const displayAmount = fixedToDisplayUnit(amount, unit);
            return <Row style={rowStyle} key={productId}>
                <Col span={6}>
                    {name}
                </Col>
                <Col span={4}>
                    {`${displayAmount} ${UnitType.Label[unit]}`}
                </Col>
            </Row>
        })}
    </Card>
}